'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorToLogLevelMapper = undefined;
var _errorToLogLevelMappe;
exports.parseLocation = parseLocation;
exports.logErrorWithMapping = logErrorWithMapping;
var _errors = require('./errors');
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parseLocation(locationResponse) {
  var zipCodeResource = locationResponse.data;
  var zipCodeCityRelationships = zipCodeResource.relationships.cities.data;
  var zipCodeLocationData = {
    zipCode: zipCodeResource.id,
    isRural: zipCodeResource.attributes.is_rural
  };
  if (zipCodeCityRelationships.length > 0) {
    var includedResources = locationResponse.included;
    var cityId = zipCodeCityRelationships[0].id;
    var cityResource = includedResources.filter(function (resource) {
      return resource.type === 'cities' && resource.id === cityId;
    })[0];
    var stateId = cityResource.relationships.state.data.id;
    var stateResource = includedResources.filter(function (resource) {
      return resource.type === 'states' && resource.id === stateId;
    })[0];
    return Object.assign({
      cityName: cityResource.attributes.name,
      stateAbbreviation: stateResource.attributes.abbreviation
    }, zipCodeLocationData);
  }
  return zipCodeLocationData;
}
var DEFAULT_LOG_LEVEL = 'critical';
var errorToLogLevelMapper = exports.errorToLogLevelMapper = (_errorToLogLevelMappe = {}, _defineProperty(_errorToLogLevelMappe, DOMException, function (exception) {
  return exception.name === 'AbortError' ? 'info' : DEFAULT_LOG_LEVEL;
}), _defineProperty(_errorToLogLevelMappe, _errors.ServerError, function () {
  return DEFAULT_LOG_LEVEL;
}), _defineProperty(_errorToLogLevelMappe, _errors.ClientError, function (error) {
  return error.errorCodes && error.errorCodes[0].code === 'write_unmodifiable' ? 'info' : DEFAULT_LOG_LEVEL;
}), _defineProperty(_errorToLogLevelMappe, _errors.NetworkError, function () {
  return 'info';
}), _errorToLogLevelMappe);
function logErrorWithMapping(error, logLevelMapping, logger) {
  var logClass = error.constructor;
  var logLevel = logLevelMapping[logClass] && logLevelMapping[logClass](error) || DEFAULT_LOG_LEVEL;
  logger.log(logLevel, {
    message: 'logErrorWithMapping ' + logLevel + ' log',
    exception: error
  });
}